var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "worldview-detail" }, [
    _c(
      "div",
      [
        _c("image-view", {
          staticClass: "worldview-image",
          attrs: {
            src: _vm.getWorldViewKey,
            placeholder: "/img/placeholders/worldview.png",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "detail-content" },
      [
        _c("div", { staticClass: "detail-header" }, [
          _c("div", { staticClass: "worldview-name" }, [
            _vm._v(_vm._s(_vm.worldView.name)),
          ]),
          _vm.editorMenuVisible
            ? _c(
                "div",
                { staticClass: "history-icon-container" },
                [
                  _c("history-icon", {
                    staticClass: "history-icon",
                    attrs: { fillColor: "#a0a0a0" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("showHistoryDialog")
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("hr"),
        _c("attribute", {
          attrs: {
            "is-detail": "",
            "hide-on-empty": "",
            name: _vm.$t("worldViewPage.worldViewDetail.period"),
            value: _vm.detail.period,
          },
        }),
        _c("attribute", {
          attrs: {
            "is-detail": "",
            "hide-on-empty": "",
            name: _vm.$t("worldViewPage.worldViewDetail.law"),
            value: _vm.detail.law,
          },
        }),
        _c("attribute", {
          attrs: {
            "is-detail": "",
            "hide-on-empty": "",
            name: _vm.$t("worldViewPage.worldViewDetail.politics"),
            value: _vm.detail.politics,
          },
        }),
        _c("attribute", {
          attrs: {
            "is-detail": "",
            "hide-on-empty": "",
            name: _vm.$t("worldViewPage.worldViewDetail.economy"),
            value: _vm.detail.economy,
          },
        }),
        _c("attribute", {
          attrs: {
            "is-detail": "",
            "hide-on-empty": "",
            name: _vm.$t("worldViewPage.worldViewDetail.military"),
            value: _vm.detail.military,
          },
        }),
        _c("attribute", {
          attrs: {
            "is-detail": "",
            "hide-on-empty": "",
            name: _vm.$t("worldViewPage.worldViewDetail.religion"),
            value: _vm.detail.religion,
          },
        }),
        _c("attribute", {
          attrs: {
            "is-detail": "",
            "hide-on-empty": "",
            name: _vm.$t("worldViewPage.worldViewDetail.history"),
            value: _vm.detail.history,
          },
        }),
        _c("attribute", {
          attrs: {
            "is-detail": "",
            "hide-on-empty": "",
            name: _vm.$t("worldViewPage.worldViewDetail.language"),
            value: _vm.detail.language,
          },
        }),
        _c("attribute", {
          attrs: {
            "is-detail": "",
            "hide-on-empty": "",
            name: _vm.$t("worldViewPage.worldViewDetail.environment"),
            value: _vm.detail.environment,
          },
        }),
        _c("attribute", {
          attrs: {
            "is-detail": "",
            "hide-on-empty": "",
            name: _vm.$t("worldViewPage.worldViewDetail.lifestyle"),
            value: _vm.detail.lifestyle,
          },
        }),
        _c("attribute", {
          attrs: {
            "is-detail": "",
            "hide-on-empty": "",
            name: _vm.$t("worldViewPage.worldViewDetail.other"),
            value: _vm.detail.other,
          },
        }),
        _vm._l(_vm.additionalColumn, function (item) {
          return [
            _c("attribute", {
              key: item.name,
              attrs: { "is-detail": "", name: item.label, value: item.content },
            }),
          ]
        }),
      ],
      2
    ),
    _vm.editorMenuVisible
      ? _c(
          "div",
          [
            _c(
              "button-round",
              {
                staticClass: "worldview-detail-edit-button",
                attrs: {
                  to: {
                    name: "worldViewEdit",
                    params: {
                      novelId: _vm.novelId,
                      worldViewId: _vm.worldView.worldViewId,
                      edit: "edit",
                    },
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("common.edit")) + " ")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }